import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=c7996e2a&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7996e2a')) {
      api.createRecord('c7996e2a', component.options)
    } else {
      api.reload('c7996e2a', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=c7996e2a&", function () {
      api.rerender('c7996e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4Ge0Wfex2jxde/JS/comp/star-display.vue"
export default component.exports